
export const getWaveReference = (app, params) => {
  const url = 'oms/control_record/wave_reference';
  const service = app.service(url);
  return service.create(null, params);
};

export const reallocateControlRecord = (app, data, params) => {
  const url = 'oms/control_record/reallocate';
  const service = app.service(url);
  const cleanData = cleanUpControlRecords(data);
  return service.create(cleanData, params);
};


export const holdItemLine = (app, data, params) => {
  const url = 'oms/control_record/hold';
  const service = app.service(url);
  const cleanData = cleanUpControlRecords(data);
  return service.create(cleanData, params);
};

export const updateControlRecords = (app, data, params) => {
  const url = 'oms/control_record'; 
  const service = app.service(url);
  const cleanData = cleanUpControlRecords(data);
  return service.create(cleanData, params);
};

function cleanUpControlRecords(controlRecords) {
  return controlRecords.map((cr) => {
    delete cr.customer;
    delete cr.sale_transaction;
    delete cr.location;
    delete cr.item;
    delete cr.delivery_address;
    delete cr.shipping_method;
    delete cr.status;
    return cr;
  })
}